module.exports = __webpack_public_path__ + "img/fontBgColor.ffaea32d.svg";